jQuery(function ($) {
	// タイトル系にjs-in, js-in--upを付与（DOM構築後すぐ）
	$('.c-title--main__ja, .c-title--center-line .title').each(function(){
		$(this).addClass('js-in js-in--up');
    });

	function scrollChk() {
	var scroll = $(window).scrollTop();
	var windowHeight = $(window).height();

		// 視界に入ったらファイドイン
		jQuery('.js-in').not('.is-active').each(function () {
			var pos = $(this).offset().top;

			if (scroll > pos - windowHeight) {
				$(this).addClass("is-active");
			}
		});

		// 順番フェイドイン
		if (window.matchMedia("(min-width: 767px)").matches) {
			var setHeight = 200;
		} else {
			var setHeight = 100;
		}

		$('.fadeIn_list').each(function () {
			var targetPosition = $(this).offset().top;
			if (scroll > targetPosition - windowHeight + setHeight) {
				$(this).addClass('show');
			}
		})
	}
	$(window).scroll(function () {
		scrollChk();
	});
	$('body').on('touchmove', function () {
		scrollChk();
	});
	// 初回表示時にも実行
	scrollChk();
});

$(window).on("load", function () {
	//ロードしてからスライド
	$('.js-load').delay(500).queue(function () {
		$(this).addClass('is-active').dequeue();
	});

	$('.js-load-more').delay(1000).queue(function () {
		$(this).addClass('is-active').dequeue();
	});
});


// タイトル系にjs-in, js-in--upを付与（DOM構築後に実行）
jQuery(function($){
	$('.c-title--main__ja, .c-title--center-line .title').each(function(){
		$(this).addClass('js-in js-in--up');
	});
});


// 投稿一覧系の処理
class PostFieldScrollManager {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
        this.handleLinks([
        '.post-field__top-link',
        '.c-pager .nav-links a',
        '.p-archive--event__nav a',
        '.p-archive--case__search'
      ]);
      this.handlePageLoad();

      // 検索ボタン（form の submit ボタン）でも同様にスクロールフラグをセットする
      const searchButtons = document.querySelectorAll('.p-archive--case__search');
      if (searchButtons.length) {
        searchButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            try {
              sessionStorage.setItem('scrollToPostField', 'true');
            } catch (e) {
              // sessionStorage が使えない環境では何もしない
            }
          });
        });
      }
    });
  }

  handleLinks(selectors) {
    // 複数セレクタのリンクに同じ処理をまとめて適用
    const links = document.querySelectorAll(selectors.join(','));
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        if (link.hostname === window.location.hostname) {
          const url = new URL(link.href);
          url.hash = 'post-field';
          sessionStorage.setItem('scrollToPostField', 'true');
          window.location.href = url.toString();
          e.preventDefault();
        }
      });
    });
  }

  handlePageLoad() {
    // ページ読み込み時にスクロールフラグをチェック
    if (sessionStorage.getItem('scrollToPostField') === 'true') {
      sessionStorage.removeItem('scrollToPostField');

      // 少し遅延させてスクロール実行
      setTimeout(() => {
        this.scrollToPostField();
      }, 100);
    }

    // URLにハッシュが含まれている場合の処理
    if (window.location.hash === '#post-field') {
      setTimeout(() => {
        this.scrollToPostField();
      }, 100);
    }
  }

  getHeaderHeight() {
    // ヘッダーのDOM要素を取得（複数のセレクターで対応）
    const headerSelectors = [
      'header',
      '.l-header',
      '.site-header',
      '#header',
      '.header',
      '.l-header-2025',
      '.p-header'
    ];

    let headerHeight = 0;

    for (const selector of headerSelectors) {
      const header = document.querySelector(selector);
      if (header) {
        // 固定ヘッダーかどうかをチェック
        const computedStyle = window.getComputedStyle(header);
        const position = computedStyle.position;

        if (position === 'fixed' || position === 'sticky') {
          const rect = header.getBoundingClientRect();
          headerHeight = rect.height;
          break;
        }
      }
    }

    // ヘッダーが見つからない場合はデフォルト値
    return headerHeight || 80;
  }

  scrollToPostField() {
    const target = document.getElementById('post-field');
    if (target) {
      const headerOffset = this.getHeaderHeight();
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset - 20; // 余白20px追加

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });

      // JavaScriptのみでスクロールマージンを設定
      this.setScrollMargin(target, headerOffset);
    }
  }

  setScrollMargin(element, headerHeight) {
    // 要素にスクロールマージンを動的に設定
    element.style.scrollMarginTop = `${headerHeight + 20}px`;

    // 関連する要素にも同様のマージンを設定
    const relatedElements = document.querySelectorAll('.p-archive__post, .c-pager');
    relatedElements.forEach(el => {
      el.style.scrollMarginTop = `${headerHeight + 20}px`;
    });
  }
}

// 初期化
new PostFieldScrollManager();
